"use client"

export { TypingAnimation } from "@/components/ui/typing-animation"